import { render, staticRenderFns } from "./kitchen-documents-list.vue?vue&type=template&id=cb2b295a&"
import script from "./kitchen-documents-list.vue?vue&type=script&lang=js&"
export * from "./kitchen-documents-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports